import dayjs from "dayjs"
import "dayjs/locale/de"
import minMax from "dayjs/plugin/minMax"

export default function installPlugins() {
  dayjs.extend(minMax)
}
